import { Modal } from "antd";
import { Button as MuiButton } from "@mui/material";
import i18next from "i18next";

export const showWarning = (message) =>
  new Promise((resolve) => {
    const manageModal = Modal.confirm({
      className: "hide-modal-footer",
      title: i18next.t("warning"),
      icon: null,
      bodyStyle: { direction: i18next.t("direction") },
      content: (
        <div>
          <div style={{ marginBottom: "20px" }}>
            {i18next.t(message)}
          </div>
          <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}>
            <MuiButton
              onClick={() => {
                manageModal.destroy();
                resolve(false);
              }}
              variant="outlined"
              size="large"
              sx={{ 
                borderRadius: "8px",
                fontWeight: "600",
                height: "40px",
                padding: "0 20px",
                fontSize: "14px",
                textTransform: "none",
                borderColor: "#FF6B35",
                color: "#FF6B35",
                "&:hover": {
                  borderColor: "#E55A2B",
                  color: "#E55A2B",
                  backgroundColor: "rgba(255, 107, 53, 0.04)"
                }
              }}
            >
              {i18next.t("cancel")}
            </MuiButton>
            <MuiButton
              onClick={() => {
                manageModal.destroy();
                resolve(true);
              }}
              variant="contained"
              size="large"
              sx={{ 
                borderRadius: "8px",
                fontWeight: "600",
                height: "40px",
                padding: "0 20px",
                fontSize: "14px",
                textTransform: "none",
                backgroundColor: "#FF6B35",
                "&:hover": {
                  backgroundColor: "#E55A2B"
                }
              }}
            >
              {i18next.t("ok")}
            </MuiButton>
          </div>
        </div>
      ),
    });
  });
